import React, { useEffect, useRef } from "react";
import { connect } from "react-redux";
import { useDeviceType } from "../helper/useDeviceType";
import {
	getProductBrands,
	ProductModalData,
} from "../store/actions/productAction";
import Favorites from "../containers/Favorites/Favorites";
import CartPopUp from "../containers/Cart/CartPopUp";
import { Spinner } from "react-bootstrap";
import { useFavorites } from "../contexts/favorites/use-favorites";
import { useCart } from "../contexts/cart/use-cart";
import { initBasket } from "../store/actions/cartAction";
import {
	FavoritesPageContainer,
	SpinnerWrapper,
} from "../containers/Favorites/Favorites.style";
import { getValue } from "../helper/constant";


const cartType = localStorage.getItem("expressMode") ? "express" : "normal";
const type = cartType === "express" ? 1 : 0;
const color = type === 1 ? "#f01266" : "#9cc54b";
const user = JSON.parse(localStorage.getItem("user"));

function FavoritesPage(props, { userAgent }) {
	const deviceType = useDeviceType(userAgent);
	const ref = useRef(null);

	const limit = useRef(null);

	const { fetchFavorites, resetLoadMoreFavorites, isLoadMore } = useFavorites();
	const { fetchOrderItems } = useCart();

	const notificationId = getValue("notificationId");

	useEffect(() => {
		sessionStorage.setItem("pageSource", "/favorites")
		if (!user) {
			// window.location.href = "/";
			localStorage.clear();
			return;
		}
		if (localStorage.getItem("expressMode")) {
			// setCartType("express");
			// setDeliveryColor("#f01266");
			props.initBasket("express");
		}
		if (!isLoadMore) {
			resetLoadMoreFavorites();
		}

		switch (true) {
			case ref.current?.clientHeight >= 1400:
				limit.current = 50;
				break;
			case ref.current?.clientHeight >= 1200:
				limit.current = 40;
				break;
			case ref.current?.clientHeight >= 920:
				limit.current = 30;
				break;
			default:
				limit.current = 20;
				break;
		}
		fetchFavorites({ type, page: 1, limit: limit.current, notificationId: (notificationId !== undefined && notificationId !== "undefined" && notificationId !== null) ? notificationId :null });
		fetchOrderItems(cartType);
		props.getProductBrands();
	}, []);

	const Loading = (position = null) => {
		return (
			<SpinnerWrapper style={{ position }}>
				<Spinner animation="grow" size="sm" style={{ color }} />
				<Spinner animation="grow" size="sm" style={{ color }} />
				<Spinner animation="grow" size="sm" style={{ color }} />
			</SpinnerWrapper>
		);
	};

	return (
		<>
			<FavoritesPageContainer ref={ref}>
				<Favorites
					props={props}
					notificationId={notificationId}
					cartType={cartType}
					type={type}
					color={color}
					limit={limit}
					loader={Loading}
				/>
			</FavoritesPageContainer>

			<CartPopUp deviceType={deviceType} />
		</>
	);
}

const mapStateToProps = (state) => ({
	brands: state.productReducer.brands,
	modalData: state.productReducer.modalData,
	cartType: state.cartReducer.cartType,
});

const mapDispatchToProps = (dispatch) => {
	return {
		getProductBrands: () => getProductBrands(dispatch),
		initBasket: (data) => initBasket(data, dispatch),
		ProductModalData: (data) => ProductModalData(data, dispatch),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(FavoritesPage);
